import { extendTheme } from "native-base";
export const myTheme = extendTheme({
  colors: {
    primary: {
      "50": "#acffbb",
      "100": "#a1f6af",
      "200": "#95e4a2",
      "300": "#8ad396",
      "400": "#7ec189",
      "500": "#73b07d",
      "600": "#679e70",
      "700": "#598961",
      "800": "#4b7452",
      "900": "#3e5f43",
    },
  },
  components: { Button: { variants: { varin1: { bg: "pink.300" } } } },
});
